import React, { useContext, useEffect } from "react";
import GlobalContext from "contexts/GlobalContext";
import { SIACatalog, useTranslator } from "@sia/style-guide";
import { useHistory } from "react-router-dom";
import cmsAdapter from "../../common/Adapters/CMSAdapter/CMSAdapter";

const Catalog = () => {
  const { language, organizationCode } = useContext(GlobalContext);
  const history = useHistory();
  const translate = useTranslator();

  const getArticles = async (params) => {
    const paramsAndOrganisationCode = `${params}${organizationCode ? `&organisation=${organizationCode}` : ""}`;
    const data = await cmsAdapter.searchArticlesV2(language, paramsAndOrganisationCode);
    return data;
  };

  const getFilters = async () => {
    const data = await cmsAdapter.fetchOrgaArticlesFiltersV2(language, organizationCode);
    return data;
  };
  useEffect(() => {
    const createBrowserTitle = () => {
      const browserTitle = translate("browser.title");
      return `${translate("header.app-switcher.catalog.name")} - ${browserTitle}`;
    };
    document.title = createBrowserTitle();
  }, [translate]);
  return (
    language && (
      <SIACatalog
        lang={language}
        history={history}
        translate={(value, options) => translate(value, options)}
        getArticles={getArticles}
        getFilters={getFilters}
      ></SIACatalog>
    )
  );
};

export default Catalog;
